import * as React from "react"

const Divider = ({
  color = "blue-100",
  direction = "horizontal",
  height = "1px",
  width = "3px",
}) => (
  <div
    className={`bg-${color}`}
    style={direction === "horizontal" ? { height: height } : { width: width }}
  />
)

export default Divider
